import React from 'react'
import './../Form.css'
import {GoogleMap, LoadScript, Marker} from "@react-google-maps/api";
import {faPencilAlt, faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Modal from "react-bootstrap/Modal";
import {FormProvider, useFormContext} from "react-hook-form";
import Button from "../Button/Button";
import AutocompleteAddress from "../AutocompleteAddress/AutocompleteAddress";

const REACT_APP_MAP_API_KEY = process.env.REACT_APP_MAP_API_KEY;

const MapView = props => {
    const { eventAddress, data, updateAddressAction } = props;
    const { label, ...restAddressProps} = eventAddress;
    const [mapData, setMapData] =  React.useState(data);
    const [show, setShow] =  React.useState(false);
    const showModal = () => setShow(true);
    const handleClose = () => setShow(false);
    const formBinding = useFormContext();
    const {handleSubmit} = formBinding;
    const position = {lat: parseFloat(mapData.latitude),lng: parseFloat(mapData.longitude)};
    const updateAction = async(data) => {
        setMapData(data);
        if(updateAddressAction){
            updateAddressAction(data);
        }
        handleClose();
    }

    return (
        <div className="form-element">
            <label>
                <FontAwesomeIcon icon={faMapMarkerAlt} color="purple" style={{fontSize:'25px'}}/>
                &nbsp;{label}&nbsp;
                <FontAwesomeIcon icon={faPencilAlt} color="purple" style={{fontSize:'20px', float: 'right'}} onClick={showModal}/>
            </label>
            <p>{mapData.address}</p>
            <LoadScript googleMapsApiKey={REACT_APP_MAP_API_KEY}  libraries={["places"]} >
                <GoogleMap
                    mapContainerClassName="map-view"
                    center={position}
                    zoom={15}
                >
                    <Marker position={position} />
                </GoogleMap>
            </LoadScript>
            <Modal show={show} contentClassName="modal-content-centre" onHide={handleClose} size='md' centered >
                <Modal.Body>
                    <Modal.Title>Update address</Modal.Title>
                    <FormProvider {...formBinding}>
                        <form id="event-address-form" onSubmit={handleSubmit(updateAction)}>
                            <AutocompleteAddress {...restAddressProps} />
                            <Button label="Update"/>
                        </form>
                    </FormProvider>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default MapView
